import { Leaf } from "@phosphor-icons/react";
import { handleColor } from "../lib/helpers";

export const Avatar = ({ handle, size = 44 }) => {
  const color = handleColor(handle);
  return (
    <div
      className="flex items-center justify-center rounded-full shrink-0"
      style={{ width: size, height: size, backgroundColor: color }}
      data-testid="anon-avatar"
    >
      <Leaf size={size * 0.5} weight="duotone" color="#2C362B" />
    </div>
  );
};
